import React from 'react';
import { IconButton } from '@chakra-ui/react';
import ArrowIcon from '../../icons/ArrowIcon';
const NavigationButton = ({ iconDirection, ...rest }) => {
    const styles = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '55px',
        height: '48px',
        boxSizing: 'border-box',
        zIndex: 1,
        boxShadow: '0',
        visibility: {
            base: 'visible',
            lg: 'visible',
            sm: 'hidden',
        },
    };
    return (React.createElement(IconButton, { sx: styles, "data-testid": "navigation_button", variant: "white-grey", icon: React.createElement(ArrowIcon, { orientation: iconDirection }), tabIndex: 0, ...rest }));
};
export default NavigationButton;
